import { updateChatProperties } from './update-chat-properties';

export async function unpinChat(chatId: string): Promise<unknown> {
  return await updateChatProperties(chatId, {
    routing: {
      pinned: false,
    },
  });
}
